import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Divider } from '@mantine/core';
import { getPrimaryColor } from '../column.utils';
export const MRT_TableHeadCellResizeHandle = ({ header, table, }) => {
    var _a;
    const { getState, options: { columnResizeMode }, setColumnSizingInfo, } = table;
    const { density } = getState();
    const { column } = header;
    return (_jsx(Box, { onDoubleClick: () => {
            setColumnSizingInfo((old) => (Object.assign(Object.assign({}, old), { isResizingColumn: false })));
            column.resetSize();
        }, onMouseDown: header.getResizeHandler(), onTouchStart: header.getResizeHandler(), sx: (theme) => ({
            cursor: 'col-resize',
            marginRight: density === 'xl' ? '-24px' : density === 'md' ? '-20px' : '-14px',
            position: 'absolute',
            right: '4px',
            paddingLeft: '1px',
            paddingRight: '1px',
            '&:active > .mantine-Divider-vertical': {
                borderLeftColor: getPrimaryColor(theme),
            },
        }), style: {
            transform: column.getIsResizing() && columnResizeMode === 'onEnd'
                ? `translateX(${(_a = getState().columnSizingInfo.deltaOffset) !== null && _a !== void 0 ? _a : 0}px)`
                : undefined,
        }, children: _jsx(Divider, { orientation: "vertical", size: "lg", sx: {
                borderRadius: '2px',
                borderWidth: '4px',
                height: '24px',
                touchAction: 'none',
                transition: column.getIsResizing()
                    ? undefined
                    : 'all 100ms ease-in-out',
                userSelect: 'none',
                zIndex: 4,
            } }) }));
};
//# sourceMappingURL=MRT_TableHeadCellResizeHandle.js.map